<template>
  <div>
    <div class="row">
      <div class="col-md-4 col-sm-12">
        <transportation-options value="139" @onChange="onOptionChange" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="Departure"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedOptionDeparture"
            :options="departureList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Partida:'"
            :disabled="transportDisabled || isEducationalService"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onDepartureChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureDirection"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.addressLine1"
            label="Dirección:"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          v-model="model.departure.addressLine2"
          label="Dirección 2:"
          :disabled="transportDisabled || disabledDeparture"
        />
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureMunicipality"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedDepartureMunicipality"
            :options="municipalityList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Municipio:'"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onDepartureMunicipalityChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureZipcode"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.zipCode"
            label="Zipcode:"
            maxlength="5"
            mask-type="Zipcode"
            placeholder="#####"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureEstate"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.state"
            label="Estado:"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureEstate"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.phone"
            label="Tel.:"
            :disabled="transportDisabled || disabledDeparture"
            :mask-type="'Phone'"
            placeholder="(787) ###-####"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-2" v-if="isDepartureSchool && isFromAee">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          :value="model.departure.schoolName"
          label="Centro AEE:"
          :disabled="true"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider v-slot="{ errors }" name="place" rules="required">
          <CustomDropDown
            v-model="selectedOptionPlace"
            :options="placeList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Lugar:'"
            :disabled="transportDisabled || isEducationalService"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onPlaceChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeDirection"
          rules="required"
        >
          <CustomInput
            v-model="model.place.addressLine1"
            label="Dirección:"
            :disabled="
              (transportDisabled || disabledPlace) && !hasEditPermission
            "
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          v-model="model.place.addressLine2"
          label="Dirección 2:"
          :disabled="(transportDisabled || disabledPlace) && !hasEditPermission"
        />
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeMunicipality"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedPlaceMunicipality"
            :options="municipalityList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Municipio:'"
            :disabled="
              (transportDisabled || disabledPlace) && !hasEditPermission
            "
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onPlaceMunicipalityChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeZipcode"
          rules="required"
        >
          <CustomInput
            v-model="model.place.zipCode"
            label="Zipcode:"
            maxlength="5"
            mask-type="Zipcode"
            placeholder="#####"
            :disabled="
              (transportDisabled || disabledPlace) && !hasEditPermission
            "
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeEstate"
          rules="required"
        >
          <CustomInput
            v-model="model.place.state"
            label="Estado:"
            :disabled="
              (transportDisabled || disabledPlace) && !hasEditPermission
            "
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placePhone"
          rules="required"
        >
          <CustomInput
            v-model="model.place.phone"
            label="Tel.:"
            :disabled="
              (transportDisabled || disabledPlace) && !hasEditPermission
            "
            :mask-type="'Phone'"
            placeholder="(787) ###-####"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-2" v-if="isPlaceSchool && isFromAee">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          :value="model.place.schoolName"
          label="Centro AEE:"
          :disabled="true"
        />
      </div>
    </div>
    <div class="col-12 mt-4">
      <ValidationProvider
        v-slot="{ errors }"
        name="Justificacion"
        rules="required"
      >
        <CustomTextArea
          v-model="model.justification"
          :label="'Justificación:'"
          :placeholder="'Escribe algo...'"
          :error="errors[0]"
          :custom-error-msg="
            errors ? 'Favor de escribir la justificación.' : ''
          "
          :rows="4"
          :maxlength="3000"
          :disabled="transportDisabled"
        />
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import {
  CustomDropDown,
  CustomTextArea,
  CustomInput,
} from '@/components/common';
import { ValidationProvider } from 'vee-validate';
import TransportationOptions from '@/components/pei/service/components/transport-detail/TransportationOptions.vue';
import locationTypes from '@/utils/constants/LocationTypes';
import PeiAnalysisService from '@/utils/constants/pei/peiAnalysisService';

import store from '@/store/index';
export default {
  name: 'TransportRegular',
  data() {
    return {
      model: {},
      municipalities: [],
      selectedOptionDeparture: null,
      selectedOptionPlace: null,
      selectedDepartureMunicipality: null,
      selectedPlaceMunicipality: null,
    };
  },
  computed: {
    isDepartureSchool() {
      return this.model.departureCode == locationTypes.Escuela;
    },
    isPlaceSchool() {
      return this.model.placeCode == locationTypes.Escuela;
    },
    isEducationalService() {
      return this.model.serviceType == PeiAnalysisService.Educativo;
    },
    hasEditPermission() {
      return store.getters.HasPermission('pei.transportation.school');
    },
  },
  methods: {
    onOptionChange(item) {
      this.$emit('onTransportTypeChange', item.id);
    },
    onDepartureMunicipalityChange() {
      this.model.departure.municipalityId = this.selectedDepartureMunicipality?.id;
    },
    onPlaceMunicipalityChange() {
      this.model.place.municipalityId = this.selectedPlaceMunicipality?.id;
    },
    onDepartureChange() {
      this.model.departureCode = this.selectedOptionDeparture?.id;

      if (this.disabledDeparture) {
        this.model.departure = this.clearDirection();
        this.selectedDepartureMunicipality = null;
      }
    },
    onPlaceChange() {
      this.model.placeCode = this.selectedOptionPlace?.id;

      if (this.disabledPlace) {
        this.model.place = this.clearDirection();
        this.selectedPlaceMunicipality = null;
      }
    },
    clearDirection() {
      return {
        addressLine1: '',
        addressLine2: '',
        municipalityId: '',
        phone: '',
        state: '',
        zipCode: '',
      };
    },
    setMunicipality(municipalityId, municipalityKey) {
      if (this.municipalityList.length === 0) return;

      if (municipalityId && municipalityId > 0)
        this[municipalityKey] = this.municipalityList.find(
          (x) => x.id === municipalityId
        );
    },
  },
  props: {
    departureList: {
      type: Array,
      default: () => [],
    },
    placeList: {
      type: Array,
      default: () => [],
    },
    transportDisabled: {
      type: Boolean,
      default: () => false,
    },
    disabledDeparture: {
      type: Boolean,
      default: () => false,
    },
    disabledPlace: {
      type: Boolean,
      default: () => false,
    },
    municipalityList: {
      type: Array,
      default: () => [],
    },
    isFromAee: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => ({
        departureCode: 0,
        placeCode: 0,
        specialEquipmentCode: 0,
        acompanyCode: '',
        mileage: 0,
        startDate: '',
        endDate: '',
        peiAnalysisServiceCode: 0,
        justification: '',
        departure: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
        place: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
      }),
    },
  },
  created() {
    this.model = this.value;
  },
  mounted() {
    let transInfo = store.getters.getPeiTransportationInfo;

    if (transInfo.departureCode != null && transInfo.placeCode != null) {
      this.selectedOptionDeparture = this.departureList.find(
        (item) => item.id == transInfo.departureCode
      );
      this.selectedOptionPlace = this.placeList.find(
        (item) => item.id == transInfo.placeCode
      );
    } else {
      this.selectedOptionDeparture = this.departureList.find(
        (item) => item.id == locationTypes.Hogar
      );
      this.selectedOptionPlace = this.placeList.find(
        (item) => item.id == locationTypes.Escuela
      );
      this.model.departureCode = this.selectedOptionDeparture.id;
      this.model.placeCode = this.selectedOptionPlace.id;
    }
  },
  watch: {
    'model.departure.municipalityId'(value) {
      this.setMunicipality(value, 'selectedDepartureMunicipality');
    },
    'model.place.municipalityId'(value) {
      this.setMunicipality(value, 'selectedPlaceMunicipality');
    },
    municipalityList(value) {
      if (value && value.length > 0) {
        const depatureMunicipalityId = this.model.departure.municipalityId;
        const placeMunicipalityId = this.model.place.municipalityId;

        if (depatureMunicipalityId > 0)
          this.setMunicipality(
            depatureMunicipalityId,
            'selectedDepartureMunicipality'
          );
        if (placeMunicipalityId > 0)
          this.setMunicipality(
            placeMunicipalityId,
            'selectedPlaceMunicipality'
          );
      }
    },
  },
  components: {
    CustomDropDown,
    CustomTextArea,
    ValidationProvider,
    TransportationOptions,
    CustomInput,
  },
};
</script>
